import { QueovalBase, QueovalDateTime } from '../global';
import { Select } from '../utilities';

/**
 * Attention le modèle s'appelle ici "HistoriqueModel" (et non HistoryModel) pour ne pas être confondu avec celui de l'elearning !
 **/
export class HistoriqueModel extends QueovalBase {
  public LogoCollaboConnected: string;
  public MaxLengthValue: number;
  public BoTypeValue: string;
  public BoTypes: Array<Select>;
  public SelectedHistory: Historique;
  public ListHistories: Array<Historique>;
  public pageIndex: number;
  public pageSize: number;
  public pageLength: number;
  public IdClient: string;
  public IdContactPrincipal: string;

  public IdPere: string;

  // liste de contacts (pour certains modes)
  public ListContact: Array<Select>;
  // Type de l'historique : ACTIONCO, STAGE...
  public Type: string;
}

export class Historique {
  public Id: string;
  public BoTypeValue: string;
  public BoTypes: Array<Select>;
  public BoTypeText: string;
  public Value: string;
  public Detail: string;
  public Date: QueovalDateTime;
  public ModeHisto: string;
  public EtatHisto: string;
  public Person: HistoryPerson;
  public ReadOnly: boolean;
  // propriété pour l'affichache des blocs sous les commentaires : RESPONSE & DELETE
  public CommentTemplate: string;
  public Responses: Array<HistoryResponse>;
  public NewResponse: string;
}

export class HistoryPerson extends Select {
  public FirstName: string;
  public LastName: string;
  public ProfilePicture: string;
}

export class HistoryResponse {
  public NamePerson: string;
  public Date: QueovalDateTime;
  public Value: string;
}

/**
 * Constantes des modes d'historiques disponibles
 **/
export enum HistoryMode {
  COMMENT = "COMMENT",
  SENDMAIL = "SENDMAIL",
  CREATE = "CREATE",
  UPDATE = "UPDATE",
  WIN = "WIN",
  LOSE = "LOSE",
  INFO = "INFO"
}
